import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';

const MovementsUIContext = createContext();
const { initialFilter } = UIHelpers();

export function useMovementsUIContext () {
    return useContext(MovementsUIContext);
}

export const MovementsUIConsumer = MovementsUIContext.Transaction;

export function MovementsUIProvider ({ transactionsUIEvents, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const movement = {};

    const value = {
        isLoading,
        setIsLoading,
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        movement
    };

    return <MovementsUIContext.Provider value={value}>{children}</MovementsUIContext.Provider>;
}
